import { WebStorageStateStore } from 'oidc-client-ts'
import type { AuthProviderProps } from 'react-oidc-context'

const oidKeycloakConfig: AuthProviderProps = {
  authority: `${import.meta.env.VITE_APP_KEYCLOAK_URL}/realms/${
    import.meta.env.VITE_APP_KEYCLOAK_REALM
  }`,
  client_id: import.meta.env.VITE_APP_KEYCLOAK_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_APP_KEYCLOAK_INIT_REDIRECT_URI,
  userStore: new WebStorageStateStore({
    store: globalThis.window.localStorage,
  }),
  silent_redirect_uri: import.meta.env.VITE_APP_KEYCLOAK_URL,
  post_logout_redirect_uri: import.meta.env.VITE_APP_KEYCLOAK_INIT_REDIRECT_URI,
  automaticSilentRenew: true,
  onSigninCallback: (): void => {
    globalThis.window.history.replaceState(
      {},
      document.title,
      globalThis.window.location.pathname
    )
  },
}

export { oidKeycloakConfig }
